import { AxiosInstance } from 'axios';

import { Invoice } from '@src/types/api/models/invoice';

export class InvoiceService {
  constructor(protected networkService: AxiosInstance) {}

  private static getBaseUrl(tripId: string) {
    return `/reservation/v1/${tripId}/invoices`;
  }

  async getLatestInvoice(tripId: string): Promise<Invoice | null> {
    const response = await this.networkService.get(`${InvoiceService.getBaseUrl(tripId)}/latest`);

    return response.data.data;
  }

  async getPdf(tripId: string, invoiceId: string) {
    const response = await this.networkService.get(`${InvoiceService.getBaseUrl(tripId)}/${invoiceId}/pdf`);
    const pdfBase64: string = response.data.data;

    return {
      pdf: pdfBase64,
      fileName: InvoiceService.generateFileName(invoiceId),
    };
  }

  private static generateFileName(invoiceId: string) {
    return `numa_INVOICE_${invoiceId}.pdf`;
  }
}
